import { render, staticRenderFns } from "./baggage_modal.vue?vue&type=template&id=c02d3a94&scoped=true&"
import script from "./baggage_modal.vue?vue&type=script&lang=js&"
export * from "./baggage_modal.vue?vue&type=script&lang=js&"
import style0 from "./baggage_modal.vue?vue&type=style&index=0&id=c02d3a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02d3a94",
  null
  
)

export default component.exports